// @dev - all role powers enum value constants to be defined here

export const CREATOR_ROLE_POWER = 0;
